import { Grid, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import * as React from "react";
import { styles } from "./BillingForm.styles";
import { BlueButton } from "../../Buttons/BlueButton";
import UserDetailsModel from "../../../../models/user/UserDetailsModel";
import { FormTextField } from "../../FormComponents/FormTextField";
import { useTranslation } from "react-i18next";
import { isPermissionGranted } from "../../../../utilities/permissionUtils";
import { useGetRoles } from "../../../../hooks/useGetRole";

export interface IBillingFormProps extends WithStyles<typeof styles> {
    userDetails: UserDetailsModel;
    onSave: any;
}

const BillingFormPure: React.FunctionComponent<IBillingFormProps> = ({
    onSave,
    userDetails,
    classes
}: IBillingFormProps) => {
    const [details, setDetails] = React.useState({
        company: userDetails.company,
        tin: userDetails.tin
    });

    const handleChange = event => {
        const name = event.target.name;
        const value = event.target.value;

        setDetails({
            ...details,
            [name]: value
        });
    };

    const handleSave = () => {
        userDetails.company = details.company;
        userDetails.tin = details.tin;

        onSave(userDetails);
    };

    const { t } = useTranslation();
    const isDisabled = !isPermissionGranted(useGetRoles(), "users.write");

    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <FormTextField
                        id="company"
                        onChange={handleChange}
                        value={details.company}
                        label={t("general.company")}
                        disabled={isDisabled}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormTextField
                        id="tin"
                        onChange={handleChange}
                        value={details.tin}
                        label={t("userManagement.taxIdVat")}
                        disabled={isDisabled}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <BlueButton onClick={handleSave} disabled={isDisabled}>
                        {t("general.save")}
                    </BlueButton>
                </Grid>
            </Grid>
        </>
    );
};

export const BillingForm = withStyles(styles)(BillingFormPure);
